/* Component used on the top of all pages to 
   display that page's title and other information */
import React from "react";

import { Col, Row, Image } from "react-bootstrap";
import door from "../assets/door.png";
import { useCurrentUser } from "../contexts/CurrentUserContext";
import { toTitleCase } from "../utils/utils";

import styles from "../styles/TopBox.module.css";

function TopBox(props) {
  const user = useCurrentUser();
  const projectType = user?.project_category_type
    ? JSON.parse(user?.project_category_type)
    : null;
  const { second, title, scene, title2, title3, title4, work, episodeTitle, sceneID } =
    props;
// function toTitleCase(str) {
//     return str
//       .toLowerCase() // Convert entire string to lowercase
//       .split(" ") // Split by spaces
//       .map((word) => {
//         // Capitalize the first letter of each word
//         return word.charAt(0).toUpperCase() + word.slice(1);
//       })
//       .join(" "); // Join the words back together with spaces
//   }

  return (
    <div className={styles.RegBox}>
      <Row>
        {/* down */}
        <Col
          xs={{ span: 1, offset: 1 }}
          lg={{ span: 1, offset: 3 }}
          md={{ span: 1, offset: 2 }}
          className={`text-center ${styles.Longboxl}`}
        >
          <p>F</p>
          <p>I</p>
          <p>R</p>
          <p>S</p>
          <p>T</p>
        </Col>
        <Col xs={8} md={6} lg={4}>
            <Row className={`${styles.Titlebox} px-0`}>
              <Col xs={1} className={`px-0`}>
                <Image 
                  className={`${styles.SmallPanel}`}
                  src={door}
                  alt="door"
                />
              </Col>
              <Col xs={10} className={`px-0 d-flex align-items-center justify-content-center`}>
              <div>
                  <h1 className={` text-center ${styles.TitleT}`}>
                    {toTitleCase(localStorage.getItem("projectSlug"))}{" "}
                  </h1>
                  {second && (
                    <h5 className={`pb-1 text-center ${styles.Second}`}
                    >
                      {second}{" "}
                    </h5>
                  )}
                  {projectType === "Television" && episodeTitle && (
                    <h5 className={`mb-1 text-center ${styles.Title2}`}>
                      {episodeTitle}
                    </h5>
                  )}
                  {projectType === "Television" && sceneID && (
                    <h3 className={` text-center ${styles.Title2}`}>
                      {sceneID}
                    </h3>
                  )}
                  {scene && (
                    <h3 className={` text-center ${styles.Title2}`}>
                      Scene {scene}{" "}
                    </h3>
                  )}
                  {work && (
                    <h3
                      style={{ textTransform: "uppercase" }}
                      className={`mb-1 text-center ${styles.Title}`}
                    >
                      {work}{" "}
                    </h3>
                  )}
                  {title && (
                    <h3 className={`text-center mb-1 ${styles.Title2}`}>
                      {title}{" "}
                    </h3>
                  )}
                  {title4 && (
                    <h3 className={` text-center mb-1 ${styles.Title2}`}>
                      {title4}{" "}
                    </h3>
                  )}

                  <h5
                    style={{ textTransform: "capitalize" }}
                    className={`text-center ${styles.Title3}`}
                  >
                    {title2} {title3}
                  </h5>
                </div>
              </Col>
            </Row>
        </Col>
        {/* down */}
        <Col
          xs={{ span: 1, offset: 0 }}
          lg={{ span: 1, offset: 1 }}
          md={{ span: 1, offset: 0 }}
          className={`text-center px-0 mx-0 ${styles.Longboxr}`}
        >
          <p>S</p>
          <p>L</p>
          <p>A</p>
          <p>T</p>
          <p>E</p>
        </Col>
      </Row>
    </div>
  );
}

export default TopBox;
